import $ from "jquery";
import * as language from './lang';
import configLang from './configLang';
import { getParam, deviceType } from './utils';
import * as eventUpload from "./eventUpload";
import '../img/favicon.png';

let lang = window.navigator.language || window.navigator.browserLanguage || window.navigator.systemLanguage;
lang = lang.toLowerCase();
lang = !lang ? 'en' : lang; // 如果是undefined的话就用默认英语
const $languageSelected = $('.j-language-selected');
const languageMap = {
    "en": {
        text: "English",
    },
    "fr": {
        text: "Français",
    },
    "ru": {
        text: "Русский",
    },
    "de": {
        text: "Deutsch",
    },
}

function setLang(langs, type = 'lang') {
    let realLang = '';
    let keyArr = [...Object.keys(language.lang)];
    for (let i of keyArr) {
        if (i.includes(langs)) {
            realLang = i;
            break;
        }
    }
    realLang = realLang === '' ? 'en-us' : realLang;
    return language[type][realLang] ? language[type][realLang] : language[type]['en-us'];
}

function initLang(langs) {
    if (langs.includes("fr")) {
        lang = 'fr';
        $("body").removeClass("en fr ru de").addClass("fr");
        $("html").attr("lang", "fr")
        $languageSelected.html(languageMap['fr'].text);
    } else if (langs.includes("ru")) {
        lang = 'ru';
        $("body").removeClass("en fr ru de").addClass("ru");
        $("html").attr("lang", "ru")
        $languageSelected.html(languageMap['ru'].text);
    } else if (langs.includes("de")) {
        lang = 'de';
        $("body").removeClass("en fr ru de").addClass("de");
        $("html").attr("lang", "de")
        $languageSelected.html(languageMap['de'].text);
    } else {
        lang = 'en';
        $("body").removeClass("en fr ru de").addClass("en");
        $("html").attr("lang", "en")
        $languageSelected.html(languageMap['en'].text);
    }
    // 设置页面元素语言
    for (let i of configLang) {
        $(i.el).html(setLang(langs)[i.langKey]);
    }
}

function initPage() {
    let isStore = getParam('store');  
    if(parseInt(isStore) !== 1){
        $('.j-recharge').hide();
    }
    addMeta('Keywords', getText('keyWords'));
    addMeta('description', getText('description'));
}

function addMeta(metaname, content) {
    const meta = document.createElement('meta');
    meta.content = content;
    meta.name = metaname;
    document.getElementsByTagName('head')[0].appendChild(meta);
}

function initEvent() {
    const $languageBtn = $('.j-language-btn')
    const $languageList = $('.j-language-list')

    $languageBtn.on('click', () => {
        $languageList.toggle();
    });
    $languageList.on('click', ({ target }) => {
        const curLanguage = target.dataset.language;
        const languageArr = [
            'en',
            'fr',
            'ru',
            'de',
        ];
        if (languageArr.includes(curLanguage)) {
            initLang(curLanguage);
            $languageSelected.html(languageMap[curLanguage].text);
        }
        $languageList.hide();
    });
    $('.j-recharge').on('click', () => {
        window.open('https://pay.goeofficial.com/?gameId=269&cid=official&scid=US#/')
    })
    $('.j-service').on('click', () => {
        window.open(
          'https://gabres.goeofficial.com/platform/webSupport.html?gameId=269&cid=official&scid=US#/'
        )
    })

    if (deviceType() === 'ios') {
        $('.j-google-down').hide();
        $('.j-apple-down').show();
    }
    if (deviceType() === 'android') {
        $('.j-google-down').show();
        $('.j-apple-down').hide();
    }
}

export function getText(key) {
    return setLang(lang)[key];
}

export const init = function () {
    dataLayer.push({
        event: 'entrance',
        scid: getParam('scid'),
        cid: getParam('cid')
    });
    eventUpload.init();
    // 初始化
    initLang(lang);
    initPage();
    initEvent();
};